import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomerAppRegistrations from "@/components/customers/customer_app_registrations/CustomerAppRegistrations";

const CustomerAppRegistrationsPage = () => {
  const { customerId } = useParams();
  const [customerName, setCustomerName] = useState<string>("");

  const handleCustomerLoaded = (name: string) => {
    setCustomerName(name);
  };

  return (
    <>
      <CustomerAppRegistrations
        CustomerId={Number(customerId)}
        onCustomerLoaded={handleCustomerLoaded}
        breadcrumbTitle="Customer | Integrations"
        breadcrumbSubtitle={
          customerName ? (
            <>
              Manage API integrations for customer{" "}
              <strong style={{ fontWeight: "600" }}>{customerName}</strong>
            </>
          ) : (
            "Manage API integrations for this customer"
          )
        }
      />
    </>
  );
};

export default CustomerAppRegistrationsPage;
